import { Grid, Typography, Button, Divider, Skeleton } from "@mui/material"
import moment from "moment"
import { SubscriptionTier } from "../../../../Types/Client"

export const ViewPlanSkeleton = () => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Grid display={"flex"} flexDirection={"column"}  marginTop={'40px'}>
                <Grid display={"flex"} flexDirection={"column"} width={'100%'}> 
                    <Grid display={"flex"} flexDirection={"row"}  marginBottom={1} sx={{ color: 'black.300'}}>
                        <Grid flex={0.5}>
                            <Skeleton variant="rectangular" height={'21px'} width={'100px'}/>
                        </Grid>
                        <Grid display={"flex"} flexDirection={"column"} flex={0.5} alignItems={'center'}>
                            <Skeleton variant="rectangular" height={'21px'} width={'100px'}/>
                        </Grid>
                        <Grid flex={1}>
                            <Skeleton variant="rectangular" height={'21px'} width={'100px'}/>
                        </Grid>
                    </Grid>
                    <Divider />
                </Grid>
            </Grid>
        </>
    )
}